var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boxActions-MenuProgram",
    transform: "translate(-21.000000, -193.000000)",
    stroke: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2445",
    points: "12.3076923 16 3.46389584e-14 16 3.46389584e-14 2.46153846 12.3076923 2.46153846"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-2457",
    points: "2.46153846 1.74971149e-13 14.7692308 1.74971149e-13 14.7692308 13.5384615"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.8eb9f7cf63c89f2d3e7cd2f86fb0585e.svg";
export { ForwardRef as ReactComponent };